import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Footer } from './Footer'
import { ChatWidget } from './ChatWidget'
import { FloatingWhatsApp } from './FloatingWhatsApp'
import { CartProvider } from '@/contexts/CartContext'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default function Layout() {
  return (
    <CartProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen font-sans">
        <Header />
        <main className="flex-1 bg-slate-50/50">
          <Outlet />
        </main>
        <Footer />
        <ChatWidget />
        <FloatingWhatsApp />
      </div>
    </CartProvider>
  )
}
